import ServiceInstance from './ServiceInstance';

export default class Subscription {
	constructor({serviceInstances = [], offer, ...subscription} = {}) {

		this.code = subscription.code;
		this.description = subscription.description;
		this.userAccount = subscription.userAccount;
		this.offer = offer;
		this.subscriptionDate = subscription.subscriptionDate;
		this.terminationDate = subscription.terminationDate;
		this.endAgreementDate = subscription.endAgreementDate;
		this.seller = subscription.seller;
		this.status = subscription.status;
		this.statusDate = subscription.statusDate;
		this.subscribedTillDate = subscription.subscribedTillDate;
		this.customFields = subscription.customFields && subscription.customFields.customField || [];
		this.cfValues = subscription.cfValues;
		this.terminationReason = subscription.terminationReason;
		this.accesses = subscription.accesses;
		const {subscriptionRenewal} = subscription;
		this.subscriptionRenewal = {
			initialyActiveFor: subscriptionRenewal.initialyActiveFor,
			initialyActiveForUnit: subscriptionRenewal.initialyActiveForUnit,
			autoRenew: subscriptionRenewal.autoRenew,
			daysNotifyRenewal: subscriptionRenewal.daysNotifyRenewal,
			endOfTermAction: subscriptionRenewal.endOfTermAction,
			terminationReasonCode: subscriptionRenewal.terminationReasonCode,
			renewFor: subscriptionRenewal.renewFor,
			renewForUnit: subscriptionRenewal.renewForUnit,
			extendAgreementPeriodToSubscribedTillDate: subscriptionRenewal.extendAgreementPeriodToSubscribedTillDate
		};
		this.services = serviceInstances.map(serviceInstance => new ServiceInstance(serviceInstance));

		this.products = subscription.products;
	}

}



// WEBPACK FOOTER //
// ./src/opencell/model/catalog/Subscription.js